<template>
    <div class="message has-icon is-danger" :class="{'is-hidden': !msg}">
        <div class="message-body has-text-weight-semibold">
        <span class="icon"><i class="far fa-sad-tear"></i></span>
            <p>{{ msg }}</p>
        </div>
    </div>

</template>

<script>
export default {
    props: ["msg"]
}
</script>